import {handleFileSend, handleSend} from '../handleSend'

export const ConsumeApi = {
  //
  //   *消费公共接口（40）*
  //
  // 消费相关下拉框列表接口（40,0001）
  consumeDropDownList (ListNo, CoditionList) {
    let data = {listNo: ListNo, coditionList: CoditionList}
    return handleSend(data, '40', '0001', '0', false)
  },
  // *工作时段管理（41*
  //
  // 新增/修改工作时段接口（41,0001
  handleWorkTime (data, type = 0) {
    return handleSend(data, '41', '0001', String(type))
  },
  // 查询商户工作时段接口（41,0002
  queryWorkTimeList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '41', '0002', '0', 'message')
  },
  // 删除商户工作时段接口（41,0003
  delWorkTime (data) {
    return handleSend(data, '41', '0003', '0')
  },
  // *商户结算管理（42）*
  //
  // 新增/修改商户结算资料接口（42,0001
  handleMerchantSettlementInfo (data, type = 0) {
    return handleSend(data, '42', '0001', String(type))
  },
  // 查询商户结算资料接口（42,0002
  queryMerchantSettlementInfoList (data) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '42', '0002', '0', 'message')
  },
  // 新增/修改商户交易费率接口（42,1001
  handleMerchantTaxRate (data, type = 0) {
    return handleSend(data, '42', '1001', String(type))
  },
  // 查询商户交易费率接口（42,1002
  queryMerchantTaxRateList (data) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '42', '1002', '0', 'message')
  },
  // 新增/修改商户单笔交易限额接口（42,2001
  handleMerchantSingleLimit (data, type = 0) {
    return handleSend(data, '42', '2001', String(type))
  },
  // 查询商户单笔交易限额接口（42,2002
  queryMerchantSingleLimitList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '42', '2002', '0', 'message')
  },
  //
  // *福利管理（43）*
  //
  // 福利设置接口（43,0001
  handleWelfare (data, type = 0) {
    return handleSend(data, '43', '0001', String(type))
  },
  // 查询福利设置接口（43,0002
  queryWelfareList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '43', '0002', '0', 'message')
  },
  // 优惠设置接口（43,1001
  handleDiscounts (data, type = 0) {
    return handleSend(data, '43', '1001', String(type))
  },
  // 查询集体优惠设置接口（43,1002
  queryGroupDiscounts (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '43', '1002', '0', 'message')
  },
  // 查询个人优惠设置接口（43,1003
  queryPersonDiscounts (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '43', '1003', '0', 'message')
  },
  // 优惠撤销（43,1004
  delDiscounts (data) {
    return handleSend(data, '43', '1004', '0', 'message')
  },
  //
  // *账务管理（44）*
  //
  // 充值/划拨接口（44,0001
  handleRecharge (data, type = 0) {
    return handleSend(data, '44', '0001', String(type))
  },
  // 账户交易查询接口（44,0002
  queryRechargeRecord (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '0002', String(type), 'message')
  },
  // 充值撤销接口（44,0003
  unRecharge (data) {
    return handleSend(data, '44', '0003', '0', 'message')
  },
  // 批量充值（划拨）文件导入接口（44,0004）
  batchRechargeFile (data, type) {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', type)
    fd.append('AppCode', '44')
    fd.append('BizCode', '0004')
    return handleFileSend('/uploadFiles', '44', '0004', fd, 'Alert')
  },
  // 批量充值（划拨）确认接口（44,0005）
  batchRechargeSure (data) {
    return handleSend(data, '44', '0005', '0', 'message')
  },
  // 批量充值（划拨）查询接口（44,0006
  batchRechargeQuery (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '0006', '0', 'message')
  },
  // 批量充值（划拨）明细查询接口（44,0007
  batchRechargeQueryDetail (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '0007', String(type), 'message')
  },
  // 个人账户流水查询接口（44,0008
  queryRechargeRecordNew (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '0008', String(type), 'message')
  },
  // 账户资料查询接口（44,1001
  queryAccountInfoList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '1001', String(type), 'message')
  },
  // 消费记录查询接口（44,2001
  queryConsumeRecord (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '2001', String(type), 'message')
  },
  // 个人交易流水查询接口（44,2002
  queryConsumeRecordNew (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '2002', String(type), 'message')
  },
  // 消费退货接口（44,3001
  handleConsumeReturn (data, type = 0) {
    return handleSend(data, '44', '3001', String(type))
  },
  // 收取工本费接口（44,3002
  handleCostOfProduction (data, type = 0) {
    return handleSend(data, '44', '3002', String(type))
  },
  // 查询工本费参数接口（44,3003
  queryCostOfProductionParam () {
    return handleSend({}, '44', '3003', '0', 'message')
  },
  // 销户流水查询接口（44,4001
  queryCloseAccountList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '4001', String(type), 'message')
  },
  // 结清处理接口（44,4002
  settlePersonAccount (data) {
    return handleSend(data, '44', '4002')
  },
  // 销户统计报表接口（44,4003
  queryCloseAccountTotal (data, type = 0) {
    return handleSend(data, '44', '4003', String(type))
  },
  // 销户结清日报表接口（44,4004
  queryCloseAccountDay (data, type = 0) {
    return handleSend(data, '44', '4004', String(type))
  },
  /***
   * 补单
   */
  // 补单记录查询接口（44,6001
  querySupplementList (data, type = 0) {
    return handleSend(data, '44', '6001', String(type))
  },
  // 补单交易记录查询接口（44,6002
  querySupplementTrans (data) {
    return handleSend(data, '44', '6002')
  },
  // 补单录入接口（44,6003
  handleSupplement (data) {
    return handleSend(data, '44', '6003')
  },
  // 补单撤销接口（44,6004
  refundSupplement (data) {
    return handleSend(data, '44', '6004')
  },
  /***
   * 押金管理
   */
  // 费用设置接口（44,8001
  handleFeeParam (data) {
    return handleSend(data, '44', '8001', '0')
  },
  // 查询费用设置接口（44,8002
  queryFeeParamList (data) {
    return handleSend(data, '44', '8002', '0', 'message')
  },
  // 查询费用记录接口（44,8003
  queryFeeRecordList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '44', '8003', String(type), 'message')
  },
  // 收押金接口（44,8004
  handleCollectFee (data) {
    return handleSend(data, '44', '8004', '0')
  },
  // 费用撤销接口（44,8005
  handleRevokeFee (data) {
    return handleSend(data, '44', '8005', '0')
  },
  //
  // *账务查询（45）*
  // 当前分户流水查询接口（45,0001
  querySubAccountList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '0001', String(type), 'message')
  },
  // 近期分户流水查询接口（45,0002
  querySubAccountLimitList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '0002', String(type), 'message')
  },
  // 历史分户流水查询接口（45,0003
  querySubAccountHistoryList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '0003', String(type), 'message')
  },
  // 当前交易流水查询接口（45,1001
  queryTransactionList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '1001', String(type), 'message')
  },
  // 近期交易流水查询接口（45,1002
  queryTransactionLimitList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '1002', String(type), 'message')
  },
  // 历史交易流水查询接口（45,1003
  queryTransactionHistoryList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '1003', String(type), 'message')
  },
  // 当前账务流水查询（45,2001
  queryAccTransList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '2001', String(type), 'message')
  },
  // 近期账务流水查询接口（45,2002
  queryAccTransLimitList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '2002', String(type), 'message')
  },
  // 历史账务流水查询接口（45,2003
  queryAccTransHistoryList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '45', '2003', String(type), 'message')
  },
  //   *消费应用管理（46）*
  //
  // 消费限额设置接口（46,0001
  handleSpendingLimit (data, type = 0) {
    return handleSend(data, '46', '0001', String(type))
  },
  // 查询群体消费限制接口（46,0002
  queryGroupSpendingLimitList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '46', '0002', '0', 'message')
  },
  // 查询个人消费限制接口（46,0003
  queryPersonSpendingLimitList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '46', '0003', '0', 'message')
  },
  // 消费限制撤销接口（46,0004
  delSpendingLimitList (data, type = 0) {
    return handleSend(data, '46', '0004', String(type))
  },
  // 计次消费设置接口（46,1001
  handleCountConsume (data, type = 0) {
    return handleSend(data, '46', '1001', String(type))
  },
  // 查询计次消费设置接口（46,1002
  queryCountConsumeList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '46', '1002', '0', 'message')
  },
  // 查询个人计次消费设置接口（46,1003
  queryPersonalCountConsumeList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '46', '1003', '0', 'message')
  },
  // 计次消费设置撤销接口（46,1004
  delCountConsume (data, type = 0) {
    return handleSend(data, '46', '1004', String(type))
  },
  // 人员类别定额消费设置接口（46,2001
  handlePersonSortsQuoteConsume (data, type = 0) {
    return handleSend(data, '46', '2001', String(type))
  },
  // 查询人员类别定额消费接口（46,2002
  queryPersonSortsQuoteConsume (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '46', '2002', '0', 'message')
  },
  // 人员类别定额消费设置撤销接口（46,2003
  delPersonSortsQuoteConsume (data) {
    return handleSend(data, '46', '2003')
  },
  //
  // *交易终端管理（47）*
  //
  // 新增/修改交易终端资料接口（47,0001
  handleConsumeDeviceInfo (data, type = 0) {
    return handleSend(data, '47', '0001', String(type))
  },
  // 查询交易终端资料接口（47,0002
  queryConsumeDeviceInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '47', '0002', '0', 'message')
  },
  // 工作参数设置接口（47,0004）
  setPosWorkParamter (data, type = 0) {
    return handleSend(data, '47', '0004', String(type))
  },
  // 工作参数查询接口（47,0005）
  queryPosWorkParamter (data, type = 0) {
    return handleSend(data, '47', '0005', String(type))
  },
  // 交易终端资料撤销接口（47,0003
  delConsumeDeviceInfo (data, type = 0) {
    return handleSend(data, '47', '0003', String(type))
  },
  // 终端支持介质设置接口（47，1001
  setPosTermMedia (data) {
    return handleSend(data, '47', '1001')
  },
  // 终端限制人员消费设置接口（47,1002
  setPorTermPersonType (data, type = 0) {
    return handleSend(data, '47', '1002', String(type))
  },
  // 查询设备版本升级流水接口（33,4004
  queryAppVersionUpdateRecord (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '33', '4004', '0', 'message')
  },
  //
  // *报表（49）*
  //
  // 终端交易日报表接口（49,0001）
  TermTradingDayList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0001', '0', 'message')
  },
  // 终端交易汇总报表接口（49,0002
  SumTermTrading (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0001', '0', 'message')
  },
  // 商户清算日报表接口（49,0003
  MerchantAccountDetailListOfDay (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0003', '0', 'message')
  },
  // 商户清算汇总报表接口（49,0004
  SumMerchantAccountDetail (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0004', '0', 'message')
  },
  // 终端工作时段日报表接口（49,0005
  TermWorkTimeListOfDay (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0005', '0', 'message')
  },
  // 终端工作时段汇总报表接口（49,0006
  SumTermWorkTime (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0006', '0', 'message')
  },
  // 商户工作时段汇总报表接口（49,0007
  SumMerchantWorkTime (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0007', '0', 'message')
  },
  // 充值统计报表接口（49,0008
  SumRecharge (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0008', '0', 'message')
  },
  // 应用账户余额报表接口（49,0009
  ApplicationAccountBalance (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0009', '0', 'message')
  },
  // 应收应付明细报表接口（49,0010
  ReceivableAndPayableDetail (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0010', '0', 'message')
  },
  // 应收应付汇总报表接口（49,0011
  SumReceivableAndPayable (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0011', '0', 'message')
  },
  // 个人优惠明细报表接口（49,0012
  PersonDiscountDetail (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0012', '0', 'message')
  },
  // 个人优惠汇总报表接口（49,0013
  SumPersonDiscount (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0013', '0', 'message')
  },
  // 集体优惠汇总报表接口（49,0014
  SumGroupDiscount (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0014', '0', 'message')
  },
  // ...
  testReport (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '0027', String(type), 'message')
  },
  // 当前就餐登记查询接口（49,1001
  queryCurrentMealsRegister (data, type = 0) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '1001', String(type), 'message')
  },
  // 历史就餐登记查询接口（49,1001
  queryHistoryMealsRegister (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '1002', String(type), 'message')
  },
  // 售货机出货异常记录查询接口（49,2001）
  queryAbnormalRecord (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '49', '2001', String(type), 'message')
  },
  // 售货机异常处理接口（49,2002）
  handleAbnormalRecord (data, type = 0) {
    return handleSend(data, '49', '2002', String(type))
  }
}



// WEBPACK FOOTER //
// ./src/request/Consume/consume_api.js